// OutputScreen.js
import React from "react";
import PropTypes from "prop-types";
import ActionButton from "./ActionButton";
import "./OutputScreen.css";

/* ---------- tiny helpers ---------- */
const isPlainObject = (v) =>
  typeof v === "object" && v !== null && !Array.isArray(v);

const formatPrimitive = (v) =>
  typeof v === "boolean"
    ? v.toString()
    : v === null || v === undefined
    ? "N/A"
    : v;

/* Render a value in a cell – handles every shape without mutating data */
const renderValue = (value) => {
  if (Array.isArray(value)) {
    // primitive array → comma list, object array → mini-table
    return value.every((v) => !isPlainObject(v))
      ? value.map(formatPrimitive).join(", ")
      : renderObjectArray(value);
  }
  if (isPlainObject(value)) {
    return (
      <table className="outputscreencomponent-nested-table">
        <tbody>
          {Object.entries(value).map(([k, v]) => (
            <tr key={k}>
              <td className="key">{k}</td>
              <td className="val">{formatPrimitive(v)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  return formatPrimitive(value);
};

/* Array<{…}> → one table */
const renderObjectArray = (arr) => {
  const allKeys = Array.from(new Set(arr.flatMap((o) => Object.keys(o))));

  return (
    <table className="outputscreencomponent-complex-table">
      <thead>
        <tr>
          {allKeys.map((k) => (
            <th key={k}>{k}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {arr.map((row, idx) => (
          <tr key={idx}>
            {allKeys.map((k) => (
              <td key={k}>{renderValue(row[k])}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

/* ───────────────  DROP-IN REPLACEMENT  ─────────────── */
const OutputScreen = ({ title, info, dataObjects, onContinue }) => {
  return (
    <div className="outputscreencomponent-container">
      <h1 className="outputscreencomponent-title">{title}</h1>
      <p className="outputscreencomponent-info">{info}</p>

      {/* ----------------------------------------------------------------
          2. Per-section log – see exactly what each section is given   */}
      {dataObjects.map(({ title: secTitle, data }, idx) => {
        return (
          <div key={idx} className="outputscreencomponent-section">
            <h3 className="outputscreencomponent-section-title">
              {secTitle}
            </h3>

            <table className="outputscreencomponent-simple-table">
              <tbody>
                {Object.entries(data).map(([k, v]) => (
                  <tr key={k}>
                    <td className="outputscreencomponent-key">{k}</td>
                    <td className="outputscreencomponent-value">
                      {renderValue(v)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}

      <ActionButton label="Continue" onClick={onContinue} />
    </div>
  );
};
/* ───────────────────────────────────────────────────── */


OutputScreen.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  dataObjects: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, data: PropTypes.object })
  ).isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default OutputScreen;